/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HealthCheckStatusDTO
 */
export interface HealthCheckStatusDTO {
    /**
     * 
     * @type {boolean}
     * @memberof HealthCheckStatusDTO
     */
    isHealthy: boolean;
    /**
     * 
     * @type {string}
     * @memberof HealthCheckStatusDTO
     */
    reason: HealthCheckStatusDTOReasonEnum;
}


/**
 * @export
 */
export const HealthCheckStatusDTOReasonEnum = {
    SystemHealthy: 'SYSTEM_HEALTHY',
    MonitoringNotEnabled: 'MONITORING_NOT_ENABLED',
    ManualOverride: 'MANUAL_OVERRIDE',
    MonitoringError: 'MONITORING_ERROR',
    IngestionBlocked: 'INGESTION_BLOCKED',
    IngestionManuallySuspended: 'INGESTION_MANUALLY_SUSPENDED',
    InternalProcessingLag: 'INTERNAL_PROCESSING_LAG'
} as const;
export type HealthCheckStatusDTOReasonEnum = typeof HealthCheckStatusDTOReasonEnum[keyof typeof HealthCheckStatusDTOReasonEnum];


/**
 * Check if a given object implements the HealthCheckStatusDTO interface.
 */
export function instanceOfHealthCheckStatusDTO(value: object): value is HealthCheckStatusDTO {
    if (!('isHealthy' in value) || value['isHealthy'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function HealthCheckStatusDTOFromJSON(json: any): HealthCheckStatusDTO {
    return HealthCheckStatusDTOFromJSONTyped(json, false);
}

export function HealthCheckStatusDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthCheckStatusDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'isHealthy': json['isHealthy'],
        'reason': json['reason'],
    };
}

export function HealthCheckStatusDTOToJSON(value?: HealthCheckStatusDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'isHealthy': value['isHealthy'],
        'reason': value['reason'],
    };
}

